/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React from "react";
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

function TaskMenu({ parent, callFunction }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clickMenu = (action) => {
    callFunction(parent.id, action);
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        color="info"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Icon>playlist_play</Icon>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => clickMenu("present")}>
          <Icon color="info">emoji_people</Icon>&nbsp;นำเสนอระบบ
        </MenuItem>
        <MenuItem onClick={() => clickMenu("quotation")}>
          <Icon color="info">description</Icon>&nbsp;เสนอราคา
        </MenuItem>
        <MenuItem onClick={() => clickMenu("approve")}>
          <Icon color="success">task_alt</Icon>&nbsp;อนุมัติสั่งซื้อ
        </MenuItem>
        <MenuItem onClick={() => clickMenu("develop")}>
          <Icon color="primary">computer</Icon>&nbsp;พัฒนาระบบ
        </MenuItem>
        <MenuItem onClick={() => clickMenu("implement")}>
          <Icon color="success">settings_suggest</Icon>&nbsp;ติดตั้งระบบ
        </MenuItem>
        <MenuItem onClick={() => clickMenu("success")}>
          <Icon color="success">check_circle</Icon>&nbsp;ใช้งานระบบ
        </MenuItem>
        <MenuItem onClick={() => clickMenu("reject")}>
          <Icon color="error">cancel</Icon>&nbsp;ลูกค้าปฏิเสธ
        </MenuItem>
      </Menu>
    </div>
  );
}

TaskMenu.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  callFunction: PropTypes.func.isRequired,
};

export default TaskMenu;
